<template>
    <div>
        <header>
            <Navigator/>
        </header>
      <router-view :key="$route.fullPath"></router-view>
      <footer v-if="$route.meta.showFoot">
            <div class="foolter_content" id="business">
                <h2>联系我们</h2>
                <el-row :gutter="30" style="-ms-flex-wrap:nowrap;flex-wrap: nowrap">

                    <el-col :xs="19" :sm="19" :md="19" :lg="19" :xl="19" class="leftColumn">
                        <div class="contact" v-for="(item, index) in contacts" :key="index">
                            <h3>{{item.title}}</h3>
                            <span class="item-subtitle-1">{{item.description}}</span>
                            <div>
                                <el-row class="no_padding" v-for="(inf,index) in item.info" :key="index" :gutter="10" style="-ms-flex-wrap:nowrap;flex-wrap: nowrap;padding-bottom: 20px;">
                                    <el-col :xs="4" :sm="4" :md="4" :lg="4" :xl="4">
                                        <div class="sudoku-code" :class="inf.qrCode"/>
                                    </el-col>
                                    <el-col :xs="20" :sm="20" :md="20" :lg="20" :xl="20" style="line-height: 30px;">
                                        <div class="item-subtitle">邮箱:&nbsp;{{inf.email}}</div>
                                        <div class="item-subtitle">电话:&nbsp;{{inf.phone}}</div>
                                    </el-col>
                                </el-row>
                            </div>
                        </div>
                    </el-col>
                    <el-col :xs="5" :sm="5" :md="5" :lg="5" :xl="5" class="rightColumn">
                        <h3>{{business.title}}</h3>
                        <img v-lazy="business.qrCode" width="130px"/>
                    </el-col>
                </el-row>
                <div class="trademark">
                    <span class="item-subtitle">© 深圳平安综合金融服务有限公司  版权所有    <a href="https://beian.miit.gov.cn" title="https://beian.miit.gov.cn" target="_blank">粤ICP备 2024321776号-2</a></span>
                </div>
            </div>

        </footer>
    </div>
</template>

<script>
import Navigator from "../../components/Navigator.vue";
import { MessageBox, Message } from "element-ui";
import ElCol from "element-ui/packages/col/src/col";
import ElRow from "element-ui/packages/row/src/row";

import ercode_1 from "../../assets/img/ercode_1.jpeg"

export default {
  name: "Layout",
  components: {
    Navigator,
    ElRow,
    ElCol
  },
  data() {
    return {
      contacts: [
        {
          title: "智能应用及其他",
          description: "知识库、智能客服、智能交警、智慧城市、智能应用服务",
          info: [
            {
              email: "ZHAOJINGZHI197@pingan.com.cn",
              phone: "15821881316",
              qrCode: "sudoku-ercode_1"
            },
            {
              email: "HUANGCHENGYAN712@pingan.com.cn",
              phone: "17317783400",
              qrCode: 'sudoku-ercode_2'
            },
            {
              email: "ZHANGXI880@pingan.com.cn",
              phone: "18616556108",
              qrCode: 'sudoku-ercode_3'
            }
          ]
        },
        {
          title: "音频平台",
          description: null,
          info: [
            {
              email: "CENBAOLING001@pingan.com.cn",
              phone: "13671910172",
              qrCode: 'sudoku-ercode_4'
            }
          ]
        },
        {
          title: "视频平台",
          description: null,
          info: [
            {
              email: "LIJUNZHANG121@pingan.com.cn",
              phone: "13817847567",
              qrCode: 'sudoku-ercode_5'
            }
          ]
        },
        {
          title: "人力外包",
          description: null,
          info: [
            {
              email: "YAOHONG676@pingan.com.cn",
              phone: "13151308369",
              qrCode: 'sudoku-ercode_6'
            }
          ]
        }
      ],
      business: {
        title: "关注微信公众，了解更多",
        qrCode: ercode_1
      }
    };
  }
};
</script>

<style lang="scss">
@import "../../assets/styles/main.scss";
</style>



// WEBPACK FOOTER //
// src/views/layout/index.vue